import util from '../util';

export const TRANSLATION = 'TRANSLATION';
export const TRANSLATION_UPDATE = 'TRANSLATION_UPDATE';

export const TRANSLATION_REQUEST = util.requestType(TRANSLATION);
export const TRANSLATION_SUCCESS = util.successType(TRANSLATION);
export const TRANSLATION_FAILURE = util.failureType(TRANSLATION);

export const TRANSLATION_UPDATE_REQUEST = util.requestType(TRANSLATION_UPDATE);
export const TRANSLATION_UPDATE_SUCCESS = util.successType(TRANSLATION_UPDATE);
export const TRANSLATION_UPDATE_FAILURE = util.failureType(TRANSLATION_UPDATE);

export const SET_TRANSLATION = 'SET_TRANSLATION';
